import {GameDefaultBox} from './game.default.box';
import {styledByTheme} from '../../../../../themes/architecture/styled-by-theme';
import {GameCasino777Box} from './game.casino777.box';
import {GameCisBox} from "./game.cis.box";

// TODO: address this any!!!!
export const GameBox: any = styledByTheme(GameDefaultBox)
                        .forCis(GameCisBox)
                        .forCasino777(GameCasino777Box)
                        .apply();